var $760b09448e39c6cd$exports = {};
$760b09448e39c6cd$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, "\u3001").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, " : ").concat(args.value);
  },
  "colorPicker": "\u30AB\u30E9\u30FC\u30D4\u30C3\u30AB\u30FC",
  "colorSwatch": "\u30AB\u30E9\u30FC\u30B9\u30A6\u30A9\u30C3\u30C1",
  "transparent": "\u900F\u660E",
  "twoDimensionalSlider": "2D \u30B9\u30E9\u30A4\u30C0\u30FC"
};
export { $760b09448e39c6cd$exports as default };